import { useQuery } from '@apollo/react-hooks';
import { getDietsQuery } from '../../queries/generic';

export default () => {
  const { loading, data } = useQuery(getDietsQuery);

  return { loading, diets: data && data.diets };
};
